import { render, staticRenderFns } from "./AddressesCreate.vue?vue&type=template&id=2e6290cc&"
import script from "./AddressesCreate.vue?vue&type=script&lang=js&"
export * from "./AddressesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports